let idleTime = 0;
let screenSaverVisible = false;
const screenSaverTimeout = 180000; // 3 minuto in millisecondi

// Funzione per visualizzare lo screen-saver e nascondere lo scroll
function showScreenSaver() {
  document.getElementById('screen-saver').style.display = 'block';
  document.documentElement.classList.add('no-scroll');
  screenSaverVisible = true;
}

// Funzione per nascondere lo screen-saver e ripristinare lo scroll
function hideScreenSaver() {
  document.getElementById('screen-saver').style.display = 'none';
  document.documentElement.classList.remove('no-scroll');
  screenSaverVisible = false;
}

// Aggiorna il tempo di inattività e gestisce lo screen-saver
function updateIdleTime() {
  if (!screenSaverVisible) {
    idleTime += 1000; // Aggiorna il tempo di inattività ogni secondo
    if (idleTime >= screenSaverTimeout) {
      showScreenSaver();
    }
  }
}

// Gestisce il movimento del mouse
function handleMouseMove() {
  if (screenSaverVisible) {
    hideScreenSaver();
    idleTime = 0;
  }
}

// Aggiungi un listener per il movimento del mouse
document.addEventListener('mousemove', handleMouseMove);

// Inizia il conteggio del tempo di inattività
const idleInterval = setInterval(updateIdleTime, 1000);
